/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiGatewayService } from "src/app/shared/services/api-gateway/api-gateway.service";
import { Observable, Subject } from "rxjs";
import { registerUserModel } from "../models/register-user-Model";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root",
})
export class LayoutService {
  private userName = new Subject<string>();
  private notificationstatus = new Subject<string>();
  private notifyCount = new Subject<string>();
  user$ = this.userName.asObservable();
  notificationstatus$ = this.notificationstatus.asObservable();
  notifyCount$ = this.notifyCount.asObservable();

  private maintainance = new Subject<string>();
  maintain$ = this.maintainance.asObservable();

  apiURL = "http://internal-dev.dataservices.pearsondev.tech/api/v1";
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      PearsonSSOSession: this.cookieService.get("PearsonSSOSession"),
    }),
  };
  constructor(
    private http: HttpClient,
    private _apiGatewayService: ApiGatewayService,
    private cookieService: CookieService,
    private router: Router
  ) {}

  newUser(content: any) {
    this.userName.next(content);
    this.notificationstatus.next("true");

    this.getNotificationData().subscribe((res) => {
      for (var key in res) {
        if (
          res[key].isActive == "Y" &&
          res[key].description.includes("under maintenance")
        ) {
          sessionStorage.setItem(
            "maintenance",
            JSON.stringify(res[key].description)
          );
          this.maintainance.next(res[key].description);
          this.router.navigate(["./servererror"]);
        } else {
          this.maintainance.next("");
        }
      }
      this.notifyCount.next(res.length);
      localStorage.setItem("notifyCount", res.length);
      localStorage.setItem("notificationsData", JSON.stringify(res));
      //this.notifyCount=res.length;
    });
  }

  createFeed(feeds): Observable<registerUserModel> {
    return this.http.post<registerUserModel>(
      this.apiURL + "/feedsetup/feeds",
      JSON.stringify(feeds)
    );
  }

  checktokenvalid(pessosession: string): Observable<any> {
    return this._apiGatewayService.get(
      `/userservice/getUserIdFromIAM/` + pessosession
    );
  }

  checkuserexist(userid: string) {
    return this._apiGatewayService.get(`/userservice/checkuser/` + userid);
  }

  register(data: object) {
    return this._apiGatewayService.post(`/userservice/register`, data);
  }

  getcurrencydetails() {
    return this._apiGatewayService.get(`/commonlookup/currency`);
  }

  getcountrydetails() {
    return this._apiGatewayService.get(`/commonlookup/country`);
  }

  getserverdetails() {
    return this._apiGatewayService.get(`/commonlookup/deliverymethod`);
  }

  logoutDuringLogin() {
    sessionStorage.clear();
    localStorage.clear();
    this.cookieService.deleteAll();
    this.userName.next("");
    // this.router.navigate(["login"]);
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.cookieService.deleteAll();
    this.userName.next("");
    let pearsonSSOToken = this.cookieService.get("PearsonSSOSession");
    if (pearsonSSOToken && pearsonSSOToken != null) {
      this._apiGatewayService
        .get("/userservice/logoutUserIAM/" + pearsonSSOToken)
        .subscribe((res) => {
          console.log("Logout called====>>", res);
          this.router.navigate(["logout"]);
        });
    } else {
      this.router.navigate(["logout"]);
    }
  }

  getUserDetails(userId: string): Observable<any> {
    return this._apiGatewayService.get("/userservice/getuserdetails/" + userId);
  }

  getNotificationData(): Observable<any> {
    let userdetails = JSON.parse(localStorage.getItem("userDetails"));
    return this._apiGatewayService.get(
      "/userservice/notifications/" + userdetails.userId
    );
  }
}
